
$(window).on('load', function () {
        var bosque = $("#bosque").height();
        $('#tierra').find('.inner_tierra').css('height', (bosque)/2);
        //$('#riosc').css('height', (bosque) + $('#riosc').height());*/

        var glaciar = $('#glaciar_img1').height() + $('#glaciar_img2').height();
        /*    var glaciar = $('#glaciar_img1').height() + $('#inner_glaciar1').height() + $('#inner_glaciar2').height() ;
            alert( glaciar );
*/
        if (window.matchMedia('(max-width: 768px)').matches){
            
        };

        if (window.matchMedia('(min-width: 768px)').matches){
            $('#glaciar2').find('#inner_glaciar1').css('height', (glaciar)/2);
            $('#glaciar2').find('#inner_glaciar2').css('height', (glaciar)/2);

            $("#glaciar2, [data-paroller-factor]").paroller({
    factor: 0.55,          // multiplier for scrolling speed and offset
    type: 'foreground',     // background, foreground
    direction: 'vertical' // vertical, horizontal
});

            $("#glaciar_img2, [data-paroller-factor]").paroller({
                factor: -0.16,
                type: 'foreground',
                direction: 'vertical'
            });

$("#txt01, [data-paroller-factor]").paroller({
    factor: -0.6,
    type: 'foreground',     // background, foreground
    direction: 'horizontal' // vertical, horizontal
});


$("#txt02, [data-paroller-factor]").paroller({
    factor: 0.6,
    factorSm: 0.4,
    factorLg: 0.6,
    type: 'foreground',     // background, foreground
    direction: 'horizontal' // vertical, horizontal
});

$("#tierra, [data-paroller-factor]").paroller({
    factor: 0.2,
    factorSm: 0.2,
    factorLg: 0.2,
    type: 'foreground',     // background, foreground
    direction: 'vertical' // vertical, horizontal
});

$('#riosc_nube1, [data-paroller-factor]').paroller({
                factor: -0.5,            // multiplier for scrolling speed and offset
                type: 'foreground',     // background, foreground
                direction: 'horizontal' // vertical, horizontal
            });
$('#riosc_nube2, [data-paroller-factor]').paroller({
                factor: -0.2,            // multiplier for scrolling speed and offset
                type: 'foreground',     // background, foreground
                direction: 'horizontal' // vertical, horizontal
            });
$('#riosc_nube3, [data-paroller-factor]').paroller({
                factor: 0.2,            // multiplier for scrolling speed and offset
                type: 'foreground',     // background, foreground
                direction: 'horizontal' // vertical, horizontal
            });

        };
            
        
    });

$(function() {

    $(window).scroll(function(){

        var windowHeight = $(window).scrollTop();
        var cont_maca = $("#maca_anim").offset();
        var cont_glaciar1 = $('#glaciar1').offset();
        var cont_cielo = $('#cielo').offset();

        cont_macaa = cont_maca.top;
        cont_glaciar1 = cont_glaciar1.top;
        cont_cielo = cont_cielo.top;

        if(windowHeight >= cont_macaa -250  ){  
            $('#maca1').addClass('on');     
            $('#maca2').addClass('on');
            $('#maca3').addClass('on');
            $('#maca4').addClass('on');
            $('#maca5').addClass('on');
        }

        if(windowHeight >= cont_cielo -300  ){  
            $('#cielo_nube1').addClass('on');     
            $('#cielo_nube2').addClass('on');
        }

    });

});

